import { Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { LeadForm } from "@/components/LeadForm";

export const PreventivoSection = ({ idPrefix, title, subtitle }) => (
  <section id="preventivo" className="scroll-mt-24 bg-white py-16 lg:py-24" data-testid="preventivo-section">
    <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-widest text-xmove-orange">Preventivo gratuito</p>
        <h2 className="mt-3 font-display text-3xl font-bold text-xmove-ink sm:text-4xl">{title}</h2>
        <p className="mt-4 max-w-md text-base leading-relaxed text-xmove-muted md:text-lg">{subtitle}</p>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-xmove-muted">
          Abbiamo a disposizione i migliori stock in pronta consegna presenti in Italia, di ogni marchio
          e ogni allestimento: basta indicarci la tipologia di auto che vuoi e la troviamo — anche in
          pronta consegna se serve. Tutto questo ha un costo? Assolutamente no:{" "}
          <b className="text-xmove-ink">la nostra consulenza è sempre gratuita</b>.
        </p>
        <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2">
          <span className="flex items-center gap-2">
            <span className="flex" aria-label="5 stelle">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={15} className="fill-xmove-green text-xmove-green" />
              ))}
            </span>
            <span className="text-sm font-bold text-xmove-ink">5.0</span>
            <span className="text-sm text-xmove-muted">· Recensioni Google</span>
          </span>
          <span className="text-sm font-medium text-xmove-green">Ti richiamiamo in pochi minuti</span>
        </div>
      </Reveal>
      <Reveal delay={0.12}>
        <div className="rounded-2xl border border-xmove-ink/8 bg-xmove-cream p-6 shadow-lift sm:p-8">
          <LeadForm idPrefix={idPrefix} compact />
        </div>
      </Reveal>
    </div>
  </section>
);
